import React, { Component } from 'react'
import Panel from '../Panel'

class DistCard extends Component {
  render() {
    const { item } = this.props
    const { distribution_card } = item
    return (
      <Panel
        icon="//qnm.hunliji.com/o_1d8n7rbpg1d2jvpdt73i2l1qi4j.png"
        item={item}
      >
        {distribution_card.source && (
          <div className="item">
            <span>来源&nbsp;:&nbsp;</span>
            <span>{distribution_card.source}</span>
          </div>
        )}
        {distribution_card.remark && (
          <div className="item">
            <span>原因备注&nbsp;:&nbsp;</span>
            <span>{distribution_card.remark}</span>
          </div>
        )}
      </Panel>
    )
  }
}

export default DistCard
